export const fmuKursusKategorier = [
  { nr: 7, navn: "Forhandling, Klientkonto og Hvidvask" },
  { nr: 3, navn: "God advokatskik 1" },
  { nr: 6, navn: "God advokatskik 2" },
  { nr: 4, navn: "Hovedforhandlingen" },
  { nr: 2, navn: "Kommunikation" },
  { nr: 5, navn: "Regnskabsforståelse" },
  { nr: 1, navn: "Relationen mellem advokat og klient" },
  { nr: 9, navn: "Retssagens forberedelse" },
];
